import { translate } from '@utils/i18n';
const ROOT_NAMESPACE = 'features.settings.service_titan';
export function translatorFor(section) {
    return (key, options) => translate(key, Object.assign({ namespace: `${ROOT_NAMESPACE}.${section}` }, options));
}
